import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import http from "../lib/http";
import "./RegisterDealerPage.css";
import SEO from "../components/SEO/SEO";

export default function RegisterDealerPage(){

const navigate = useNavigate();


const [categories,setCategories]=useState([]);

const [preview,setPreview]=useState(null);

const [loading,setLoading]=useState(false);

const [message,setMessage]=useState("");



const [formData,setFormData]=useState({

name:"",
contact:"",
password:"",
category:"",
address:"",
locationName:"",
latitude:"",
longitude:"",
gst:"",
pan:"",
aadhar:"",
image:null

});



useEffect(()=>{

http.get("/api/categories")
.then(res=>setCategories(res.data))
.catch(()=>{});

},[]);



const handleChange=(e)=>{

const {name,value}=e.target;

setFormData(prev=>({

...prev,

[name]:value

}));

};



const handleImageChange=(e)=>{

const file=e.target.files[0];

if(file){

setFormData(prev=>({

...prev,
image:file

}));

setPreview(
URL.createObjectURL(file)
);

}

};



const detectLocation=()=>{


navigator.geolocation.getCurrentPosition(

(pos)=>{

setFormData(prev=>({

...prev,

latitude:pos.coords.latitude,

longitude:pos.coords.longitude

}));

setMessage(
"Location detected successfully"
);

},

()=>{

setMessage(
"Unable to detect location"
);

}

);


};




const handleSubmit=async(e)=>{

e.preventDefault();


if(
!formData.name ||
!formData.contact ||
!formData.password
){

setMessage(
"Name, phone and password are required"
);

return;

}


const fd=new FormData();


Object.entries(formData)
.forEach(([key,value])=>{

if(value){

fd.append(key,value);

}

});



try{


setLoading(true);

setMessage("");



await http.post(

"/api/dealers/register",

fd,

{

headers:{
"Content-Type":"multipart/form-data"
}

}

);



setMessage(
"Registration successful. Waiting for admin approval."
);



setTimeout(()=>{

navigate("/dealer/approval");

},2000);



}
catch(err){

setMessage(
err.response?.data?.error ||
"Registration failed"
);


}
finally{

setLoading(false);

}


};



return(
<>
<SEO
    title="Become a Dealer | BuildNear"
    description="Register your construction material business with BuildNear."
    noIndex={true}
/>

<div className="dealer-register-page">



<section className="register-banner">


<img
src="/images/logo/buildnear-logo-3d-512.png"
/>


<h1>
Become a BuildNear Dealer
</h1>


<p>
Grow your construction business with India's trusted dealer network
</p>


</section>




<motion.div

className="register-card"

initial={{opacity:0,y:40}}

animate={{opacity:1,y:0}}

transition={{duration:.5}}

>



<form onSubmit={handleSubmit}>


{
message &&
<div className="register-message">
{message}
</div>
}



<div className="form-section">


<h3>
Personal Information
</h3>


<div className="form-grid">


<input
name="name"
placeholder="Full Name *"
value={formData.name}
onChange={handleChange}
/>



<input
name="contact"
placeholder="Phone Number *"
value={formData.contact}
onChange={handleChange}
/>



<input
type="password"
name="password"
placeholder="Create Password *"
value={formData.password}
onChange={handleChange}
/>



<select

name="category"

value={formData.category}

onChange={handleChange}

>


<option value="">
Select Business Category
</option>


{
categories.map(cat=>(

<option
key={cat._id}
value={cat.name}
>
{cat.name}
</option>

))
}


</select>


</div>


</div>





<div className="form-section">


<h3>
Business Location
</h3>



<input

name="address"

placeholder="Business Address"

value={formData.address}

onChange={handleChange}

/>



<div className="location-row">


<input

name="locationName"

placeholder="Area, City, Pincode"

value={formData.locationName}

onChange={handleChange}

/>


<button
type="button"
onClick={detectLocation}
>
📍 Use GPS
</button>


</div>


</div>






<div className="form-section">


<h3>
Business Verification
</h3>



<div className="form-grid">


<input

name="gst"

placeholder="GST Number"

onChange={handleChange}

/>


<input

name="pan"

placeholder="PAN Number"

onChange={handleChange}

/>


<input

name="aadhar"

placeholder="Aadhar Number"

onChange={handleChange}

/>


</div>


</div>





<div className="form-section">


<h3>
Dealer Image
</h3>


<div className="upload-box">


<input

type="file"

onChange={handleImageChange}

/>


<p>
Upload Shop / Dealer Image
</p>


</div>



{
preview &&
<img

src={preview}

className="preview-image"

alt="preview"

/>
}


</div>





<button

className="register-button"

disabled={loading}

>

{
loading
?
"Submitting..."
:
"Submit For Approval"
}


</button>



</form>


</motion.div>


</div>
</>

)

}